import React, { useEffect, useState } from "react";
import Label from "../atoms/Label";
import tick from "../../assets/plan_tick.svg"
import whiteTick from "../../assets/tick_white_green.svg"
import Button from "../atoms/Button";
import "../../styles/Plans.css"

const Plan = ({heading, subHeading, amountLabel, oldPriceLabel, features, planType = 1, bgColor, planTierId, currentPlanDetails, onButtonClick, isFirstTimeSubscriber}) => {

    const ButtonLabel = {
        START_TRIAL: "Start your free trial",
        BUY_NOW: "Buy now",
        CURRENTLY_ENROLLED: "Currently Enrolled",
        GO_TO: (heading) => `Go to ${heading}`
    };

    const buttonLabel = isFirstTimeSubscriber
    ? planType === 0 
      ? ButtonLabel.START_TRIAL
      : ButtonLabel.BUY_NOW
    : currentPlanDetails.planType === planType 
      ? ButtonLabel.CURRENTLY_ENROLLED
      : currentPlanDetails.planType > planType 
        ? ButtonLabel.GO_TO(heading)
        : ButtonLabel.BUY_NOW;

    const handlePlanActionClick = async (e, label) => {
        if (onButtonClick) {
            let action = "";
            if (label === ButtonLabel.CURRENTLY_ENROLLED) {
                action = "VIEW_PLAN";
            } else if (label === ButtonLabel.START_TRIAL || label === ButtonLabel.BUY_NOW) {
                action = "UPGRADE";
            } else {
                action = "DOWNGRADE";
            }

            onButtonClick(action, planTierId);
        }
    };



    return(
        (!isFirstTimeSubscriber && planType === 0 && currentPlanDetails.planType !== 0) ? null : (
        <div className={`plan ${currentPlanDetails && currentPlanDetails.planTierId ===  planTierId ? 'current-plan' : ''} ${isFirstTimeSubscriber && planType === 0 ? 'free-plan' : ''}`}  style={{ backgroundColor: bgColor }}>
            <div className="plan-header">
                <Label label={heading} fontWeight={"700"} fontSize={"20px" } color={planType == 0 ? ("#545454") : ("#FFFFFF")}></Label>
            </div>
            
            <div className="plan-subheader">
                <Label label={subHeading} fontWeight={"400"} fontSize={"12px" } fontStyle={"italic"} color={planType == 0 ? ("#545454") : ("#FFFFFF")}></Label>
            </div>

            <div
                    style={{
                        height: "2px",
                        backgroundColor: planType == 0 ? ("#545454") : ("#FFFFFF"),
                        marginTop: "10px",
                        marginBottom : "20px",
                        width : "235px"
                    }}
            />

            <div className="plan-amount">
                {planType !== 0 && (<Label className={"old-price"} label={oldPriceLabel} fontWeight={"700"} fontSize={"20px" } color={planType == 0 ? ("#545454") : ("#FFFFFF")}></Label>)}             
                <Label label={amountLabel} fontWeight={"700"} fontSize={"20px" }color={planType == 0 ? ("#545454") : ("#FFFFFF")}></Label>
            </div>
            

            <div className="plan-features" style={{ marginTop: "10px" }}>
                {features.map((feature, index) => (
                    <div style={{display: "flex",flexDirection : "row"}}>
                    <img src = {(planType == 0 || planType == 1) ? tick : whiteTick}/>
                    <Label
                        key={index}
                        label={feature}
                        textAlign={"justify"}
                        fontWeight={"400"}
                        fontSize={"12px"}
                        fontStyle={"italic"}
                        margin={"10px"}
                        color={planType == 0 ? ("#545454") : ("#FFFFFF")}
                    />
                    </div>
                ))}
            </div>

            <div className="plan-footer">
                <Button
                    className="plan-button"
                    onClick={(e) => handlePlanActionClick(e, buttonLabel)}
                    label={buttonLabel}
                >
                    <a href="/" />
                </Button>
            </div>
        </div>)
    );
}

export default Plan;
